import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Mail } from "lucide-react";
import { BRAND, logoImage } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-[#f1eadd] border-t border-[#e7e0d3] mt-24">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src={logoImage}
              alt="Roi des Rois Monogramm"
              className="h-16 w-16 object-cover rounded-sm border border-[#dcd4c5] mb-4"
            />
            <h3 className="font-serif text-2xl tracking-[0.18em] text-[#17140f]">
              {BRAND.name}
            </h3>
            <p className="text-gold text-[10px] tracking-[0.4em] uppercase mt-1">
              Paris
            </p>
            <p className="text-[#6b665a] text-sm mt-5 leading-relaxed max-w-xs">
              {BRAND.tagline}. Handgefertigte Extraits de Parfum in limitierter
              Auflage.
            </p>
            <div className="flex gap-4 mt-6">
              {[
                {
                  Icon: Instagram,
                  href: "https://www.instagram.com/roidesrois_official?stkn=ejhiYWNmZW0wZXRl",
                },
                { Icon: Facebook, href: "#" },
                { Icon: Twitter, href: "#" },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target={href !== "#" ? "_blank" : undefined}
                  rel={href !== "#" ? "noopener noreferrer" : undefined}
                  className="w-9 h-9 rounded-full border border-[#dcd4c5] flex items-center justify-center text-[#4a463c] hover:text-gold hover:border-gold transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Columns */}
          <FooterCol
            title="Shop"
            links={["Alle Düfte", "Limited Editions", "Bestseller", "Damen", "Herren"]}
          />
          <FooterCol
            title="Service"
            links={["Versand & Lieferung", "Rückgabe", "Kontakt", "FAQ", "Größenberatung"]}
          />

          {/* Newsletter */}
          <div>
            <h4 className="text-[12px] tracking-[0.25em] uppercase text-[#17140f] mb-5">
              Newsletter
            </h4>
            <p className="text-[#6b665a] text-sm mb-4">
              Erhalte exklusiven Zugang zu neuen Editionen.
            </p>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex items-center border-b border-[#dcd4c5] focus-within:border-gold transition-colors"
            >
              <Mail size={16} className="text-[#6b665a]" />
              <input
                type="email"
                required
                placeholder="Deine E-Mail"
                className="bg-transparent flex-1 px-3 py-3 text-sm text-[#17140f] placeholder:text-[#8d8779] focus:outline-none"
              />
              <button
                type="submit"
                className="text-gold text-[11px] tracking-[0.2em] uppercase hover:text-[#17140f] transition-colors"
              >
                Senden
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-[#e7e0d3] mt-14 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#8d8779] text-xs">
            © {new Date().getFullYear()} {BRAND.name}. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            {[
              { label: "Impressum", to: "/impressum" },
              { label: "Datenschutz", to: "/datenschutz" },
              { label: "AGB", to: "/agb" },
            ].map((l) => (
              <Link
                key={l.label}
                to={l.to}
                className="text-[#8d8779] text-xs hover:text-gold transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="text-[12px] tracking-[0.25em] uppercase text-[#17140f] mb-5">
      {title}
    </h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l}>
          <Link
            to="/shop"
            className="text-[#6b665a] text-sm hover:text-gold transition-colors"
          >
            {l}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
